import { EntityState } from '@reduxjs/toolkit';

export const wrap = <T extends { id: string }>(entities: T[]): EntityState<T> => {
    return {
        ids: entities.map(e => e.id),
        entities: entities.reduce((s, e) => ({ ...s, [e.id]: e }), {})
    };
};